import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { environment } from '../../../../../../../environments/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { RiscoPcmsoResponse } from './risco-pcmso.model';

@Injectable({ providedIn: 'root' })
export class RiscoPcmsoService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH = SICOM_PATHS.registro.medico.riscoPcmso;

    /**
     * Lista as classificações de risco PCMSO do médico.
     * GET /api/v1/cadastro/medico/risco-pcmso
     */
    listar(context?: HttpContext): Observable<RiscoPcmsoResponse[]> {
        return this.http.get<RiscoPcmsoResponse[]>(this.PATH, { context });
    }
}
